import baseConfiguratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import {
  RECEIVE_CONFIGURATION,
  RECEIVE_OPTIONS,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import get from 'lodash/get';
import { actionTypes } from './Actions';

export default function configuratorReducer(state, action) {
  switch (action.type) {
    case actionTypes.RECEIVE_LANGUAGES: {
      return {
        ...(state || {}),
        languages: action.data ?? [],
      };
    }
    case RECEIVE_CONFIGURATION: {
      const nextState = baseConfiguratorReducer(state, action);
      const { configuration } = nextState;
      const steps = get(configuration, 'information.steps', []);

      // remove information from the configuration (so it does not travel with it unnecessarily)
      delete configuration.information;

      return {
        ...nextState,
        steps,
        configuration: {
          ...configuration,
        },
      };
    }
    case RECEIVE_OPTIONS: {
      const nextState = baseConfiguratorReducer(state, action);
      // saving options array of active step optionclassification at optionClassificationOptions
      const ocOptions = [
        {
          ...nextState.selectedoptionclassification,
          options: nextState.options,
        },
      ];
      return {
        ...nextState,
        optionClassificationOptions: state.optionClassificationOptions
          ? state.optionClassificationOptions.concat(ocOptions)
          : ocOptions,
      };
    }
    case actionTypes.SET_INITIAL_ACTIVE_STEP: {
      const stepsState = state.steps.map((step, i) => ({
        identifier: step.identifier,
        state: i === 0 ? 'active' : 'disabled',
      }));
      return { ...state, stepsState };
    }
    case actionTypes.SET_STEP_STATE: {
      const stepsState = state.stepsState.map((step) => ({
        identifier: step.identifier,
        state:
          step.state === 'active' && step.identifier !== action.identifier
            ? 'enabled'
            : step.identifier === action.identifier
            ? action.state
            : step.state,
      }));
      return { ...state, stepsState };
    }
    case actionTypes.SET_OPTION_CLASSIFICATION_OPTIONS: {
      const nextState = baseConfiguratorReducer(state, action);
      const ocIdx = state.optionClassificationOptions.findIndex(
        (elem) => elem.identifier === action.payload.identifier
      );
      const optionClassification = {
        ...state.optionClassificationOptions[ocIdx],
        options: action.payload.data,
      };
      const optionClassificationOptions = [...state.optionClassificationOptions];
      optionClassificationOptions[ocIdx] = optionClassification;

      return {
        ...nextState,
        optionClassificationOptions,
      };
    }
    default: {
      return baseConfiguratorReducer(state, action);
    }
  }
}
